import { CalendarEvent } from '@models/calendar-event';
import { apiClient } from '.';

export type GetCalendarEventsParams = {
  from?: string;
  to?: string;
  search?: string;
  skip?: number;
  limit?: number;
};

export type CalendarEventsPage = {
  contents: CalendarEvent[];
  total: number;
  skip: number;
  limit: number;
  hasNext: boolean;
};

export const getCalendarEvents = async (params?: GetCalendarEventsParams) => {
  return apiClient.get<CalendarEvent[] | CalendarEventsPage>(`/admin/v1/calendar-events`, { params });
};

export const getCalendarEvent = async (id: string) => {
  return apiClient.get<CalendarEvent>(`/admin/v1/calendar-events/${id}`);
};

export const createCalendarEvent = async (formData: FormData) => {
  return apiClient.post<CalendarEvent>(`/admin/v1/calendar-events`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateCalendarEvent = async (id: string, formData: FormData) => {
  return apiClient.put<CalendarEvent>(`/admin/v1/calendar-events/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteCalendarEvent = async (id: string) => {
  return apiClient.delete(`/admin/v1/calendar-events/${id}`);
};
